module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_02.858efca6.svg";